module.exports = __webpack_public_path__ + "img/guidebook.5cbc58e7.png";